// extracted by mini-css-extract-plugin
export default {"drawer":"JYjnhdlTonc2Yq8aLn9b","left":"cTfZziVzhdYtZuDPXL0X","closed":"jSI_s7URSlg43JOKGRG0","right":"EZly759DOpdjSGEPmUTn"};